/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros
Descripcion:        Muestra un modal
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
(@#)1-A   SOL 33756    Emanuel Guivar           30/12/2025   Cambios fase 3 - Seguros desailiacion, siniestro y endosos
--------------------------------------------------------------------------------------------------------------
*/
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Helpers from '../../data/Helpers';


interface ResultModalProps {
    result: RespuestaApi | null,
    sistem: string, 
    appUser: string,  //(@#)1-A 

    onClose: () => void,

};

const ResultModal = (props: ResultModalProps) => {

    // controlar cierre de modal
    const handleClose = () => {
        setTimeout(props.onClose, 150);
    };

    // url base para pdf
    const urlPdf: string = Helpers.UrlBase +  '/SeguroPdfDescarga/GenerarPDF'; 


    // controlar apertura del modal
    useEffect(() => {
        if (props.result) ($('.ResultModal') as any).modal('show');
    }, [props.result]);

    const result = props.result || { isok: false, mensaje: '' };

    // Funci�n para renderizar los saltos de l�nea en el mensaje
    const renderMensajeConSaltos = (mensaje: string | undefined) => {
        if (!mensaje || typeof mensaje !== 'string') return <div>(Mensaje no disponible)</div>;

        return (
        <div style={{ textAlign: 'left' }}>
            {mensaje.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ))}
        </div>
        );
    };


    return ReactDOM.createPortal(
        <div className="ResultModal modal fade" tabIndex={-1} aria-labelledby="ResultModalTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false"> 
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className={`modal-header px-4 text-light ${result.isok ? 'bg-success' : 'bg-danger'}`}>
                        <h4 className="modal-title" id="ResultModalTitle">
                            {result.isok ? 'Registro correcto' : 'Hubo un problema!'}
                        </h4>
                    </div>
                    <div className="modal-body px-4">
                        <h4 className={`my-2 ${result.isok && 'text-center'}`}>{renderMensajeConSaltos(result.mensaje)}</h4>
                        {(result.isok && result.codigo) &&
                            <div className="text-center">
                            
                                <h3 className="text-center mt-3 mb-4">Ticket {result.autoId} </h3>
                             
                               
                                    <a href={`${urlPdf}?ticketid=${result.codigo}`} type="button" className="btn btn-primary bg-success">
                                        <b>Descargar PDF</b>
                                    </a>

                                
                                
                            </div>
                        }
                        {result.errores &&
                            <ul className="mt-4 mb-0 ml-n3 text-secondary" style={{ 'listStyleType': 'square' }}>
                                {result.errores.map((msj, i) => <li key={i}>{msj}</li>)}
                            </ul>
                        }
                    </div>
                    <div className="modal-footer px-4">
                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleClose}><b>Cerrar</b></button>
                    </div>
                </div>
            </div>
        </div>
        , document.getElementById('root-portal')!);
};

export default ResultModal;